import {inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser, ViewportScroller} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class ScrollerService {
  private platformId: Object = inject(PLATFORM_ID);
  private viewportScroller: ViewportScroller = inject(ViewportScroller);

  public scrollToTop(): void {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.viewportScroller.scrollToPosition([0, 0]);
      }, 20)
    }
  }
}
